module.exports = __webpack_public_path__ + "static/media/contactMailDark.ee7509b7.svg";